import Tools from './../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Home {
  constructor() {
    // Home
    this.sliders();
    this.popin();
  }

  sliders() {
    const sliders = document.querySelectorAll('.slider-container');
    if (sliders.length > 0) {
      sliders.forEach((slider) => {
        tns({
          container: slider,
          items: 1,
          slideBy: 'page',
          autoplay: false,
          navPosition: 'bottom',
          hasControls: true,
          loop: false,
          controlsText: ['', ''],
          speed: 1200,
        });
      });
    }
  }

  popin() {
    const formats = document.querySelectorAll('.home section article#prestations .formats .format');
    if (formats.length > 0) {
      formats.forEach((format) => {
        const popin = format.nextElementSibling;

        format.addEventListener('click', () => {
          popin.classList.add('open');
        });

        popin.querySelector('.close').addEventListener('click', () => {
          popin.classList.remove('open');
        });

        popin.querySelector('.overlay').addEventListener('click', () => {
          popin.classList.remove('open');
        });
      });
    }
  }
}